import { render } from "./EnvironmentOcean.vue?vue&type=template&id=b2185f12&ts=true"
import script from "./EnvironmentOcean.vue?vue&type=script&lang=ts"
export * from "./EnvironmentOcean.vue?vue&type=script&lang=ts"

import "./EnvironmentOcean.vue?vue&type=style&index=0&id=b2185f12&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__